import type { ReactNode } from 'react';

/** Card do grid em telas pequenas (substitui a tabela no mobile). */
export function ReportCard({ children }: { children: ReactNode }) {
  return (
    <article className='rounded-3xl bg-white p-4 shadow-[0px_4px_24px_rgba(15,22,30,0.08)]'>{children}</article>
  );
}

/** Skeleton de carregamento de um card. */
export function ReportCardSkeleton() {
  return <div className='h-64 animate-pulse rounded-3xl bg-alba-gray-200' />;
}

/** Cabeçalho do card: título (entidade principal), subtítulo e slot à direita. */
export function ReportCardHeader({
  title,
  subtitle,
  right,
}: {
  title?: string | null;
  subtitle?: string | null;
  right?: ReactNode;
}) {
  return (
    <div className='flex items-start justify-between gap-3'>
      <div className='min-w-0'>
        <p className='truncate font-gotham font-bold text-alba-black-500'>{title || '-'}</p>
        {subtitle ? <p className='mt-1 text-xs text-alba-gray-600'>{subtitle}</p> : null}
      </div>
      {right ? <div className='shrink-0'>{right}</div> : null}
    </div>
  );
}

/** Uma linha rótulo/valor do corpo do card. */
export function CardRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className='flex items-start justify-between gap-3'>
      <span className='shrink-0 text-sm font-semibold text-alba-black-500'>{label}</span>
      <div className='min-w-0 text-right text-sm text-alba-gray-700'>{children}</div>
    </div>
  );
}

/** Corpo do card (lista de linhas). */
export function ReportCardBody({ children }: { children: ReactNode }) {
  return <div className='mt-4 space-y-2'>{children}</div>;
}
